export default __webpack_public_path__ + "static/media/websocket.ff26e649.svg";